"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
exports.default = {
    standard: Yup.object().shape({
        labelType: Yup.string()
            .matches(/numeric/)
            .required(),
        startAt: Yup.number()
            .integer()
            .required(),
        startSlot: Yup.number()
            .min(0)
            .max(6),
        slots: Yup.array()
            .of(Yup.object().shape({
            start: Yup.number()
                .integer()
                .required(),
            end: Yup.number()
                .integer()
                .required(),
            enabled: Yup.boolean().required(),
        }))
            .min(7)
            .max(7)
            .required(),
        type: Yup.string()
            .matches(/standard/)
            .required(),
    }),
    weekly: Yup.object().shape({
        labelType: Yup.string()
            .matches(/numeric/)
            .required(),
        startAt: Yup.number()
            .integer()
            .required(),
        startSlot: Yup.number()
            .min(0)
            .max(6),
        slots: Yup.array()
            .of(Yup.object().shape({
            start: Yup.number()
                .integer()
                .required(),
            end: Yup.number()
                .integer()
                .required(),
            enabled: Yup.boolean().required(),
        }))
            .min(7)
            .max(7)
            .required(),
        type: Yup.string()
            .matches(/weekly/)
            .required(),
    }),
    rotating: Yup.object().shape({
        labelType: Yup.string()
            .oneOf(['alphabet', 'numeric'])
            .required(),
        startAt: Yup.number()
            .integer()
            .required(),
        startSlot: Yup.number()
            .min(0)
            .max(9),
        slots: Yup.array()
            .of(Yup.object().shape({
            start: Yup.number()
                .integer()
                .required(),
            end: Yup.number()
                .integer()
                .required(),
            enabled: Yup.boolean().required(),
        }))
            .min(2)
            .max(10)
            .required(),
        type: Yup.string()
            .matches(/rotating/)
            .required(),
    }),
};
